import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import {
  headerBoxSx,
  paperSx,
  skeletonHeaderTitleSx,
  skeletonSectionTitleSx,
  skeletonSectionSubtextSx,
  skeletonGridContainerSx,
  skeletonGridContainerWithMarginSx,
} from './styles';

function CustomMetricsSkeleton() {
  return (
    <>
      <Box sx={headerBoxSx}>
        <Skeleton variant='rounded' height={32} width={300} sx={skeletonHeaderTitleSx} />
        <Skeleton variant='text' width={200} />
      </Box>

      <Paper elevation={0} sx={paperSx}>
        <Skeleton variant='text' width={150} height={28} sx={skeletonSectionTitleSx} />
        <Grid container spacing={2} sx={skeletonGridContainerWithMarginSx}>
          <Grid item xs={4}>
            <Skeleton variant='rounded' height={40} />
          </Grid>
          <Grid item xs={4}>
            <Skeleton variant='rounded' height={40} />
          </Grid>
          <Grid item xs={8}>
            <Skeleton variant='rounded' height={60} />
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} sx={paperSx}>
        <Skeleton variant='text' width={150} height={28} sx={skeletonHeaderTitleSx} />
        <Skeleton variant='text' width={400} sx={skeletonSectionSubtextSx} />
        <Grid container spacing={2} sx={skeletonGridContainerSx}>
          <Grid item xs={12}>
            <Skeleton variant='rounded' height={40} width={400} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant='rounded' height={40} width={450} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Skeleton variant='rounded' height={80} width={200} />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export default CustomMetricsSkeleton;
